      <div class="modal-all">
        <!-- ---------- Header ---------- -->
        <div class="modal-header">
          <span *ngIf="!driverInfo" class="modal-header-title">
            {{ "modals.add_personal.title" | translate }}
          </span>
          <span *ngIf="driverInfo" class="modal-header-title">
            {{ "modals.add_personal.edit_title" | translate }}
          </span>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="closeCanvas()"
          ></button>
        </div>

        <!-- ---------- Body ---------- -->
        <div class="modal-body">
          <div id="modal_show_countries_phones"></div>
          <form
            [formGroup]="personalForm"
            (ngSubmit)="savePersonal()"
            class="form-container"
            novalidate
          >
            <ng-container *ngIf="personalForm">
              <!-- Nombre y Apellidos (lado a lado en pantallas grandes) -->
              <div class="row gap-2">
                <div class="form-group">
                  <label class="label_form">
                    {{ "modals.add_personal.name_input" | translate }}*
                  </label>
                  <tui-input
                    formControlName="firstName"
                    class="input_form"
                    [tuiTextfieldLabelOutside]="true"
                  >
                    {{ "modals.add_personal.name_input_inside" | translate }}
                    <input tuiTextfield type="text" />
                  </tui-input>
                  <div
                    *ngIf="
                      personalForm.get('firstName')?.hasError('required') &&
                      personalForm.get('firstName')?.touched
                    "
                  >
                    <span class="alert-text">
                      {{ "modals.add_personal.error_required" | translate }}
                    </span>
                  </div>
                </div>

                <div class="form-group">
                  <label class="label_form">
                    {{ "modals.add_personal.lastname_input" | translate }}*
                  </label>
                  <tui-input
                    formControlName="lastName"
                    class="input_form"
                    [tuiTextfieldLabelOutside]="true"
                  >
                    {{ "modals.add_personal.lastname_input_inside" | translate }}
                  </tui-input>
                  <div
                    *ngIf="
                      personalForm.get('lastName')?.hasError('required') &&
                      personalForm.get('lastName')?.touched
                    "
                  >
                    <span class="alert-text">
                      {{ "modals.add_personal.error_required" | translate }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Zona y Tipo de Operador -->
              <div class="row gap-2">
                <div class="form-group">
                  <label class="label_form">
                    {{ "modals.add_personal.zone_input" | translate }}*
                  </label>
                  <ng-select
                    formControlName="zoneId"
                    [items]="zones"
                    bindLabel="zoneName"
                    [loading]="loadingZones"
                    bindValue="zoneId"
                    class="input_form"
                    placeholder="{{
                      'modals.add_personal.zone_input_inside' | translate
                    }}"
                    [ngClass]="{
                      'has-error':
                        personalForm.get('zoneId')?.invalid &&
                        personalForm.get('zoneId')?.touched
                    }"
                  ></ng-select>
                  <div
                    *ngIf="
                      personalForm.get('zoneId')?.hasError('required') &&
                      personalForm.get('zoneId')?.touched
                    "
                  >
                    <span class="alert-text">
                      {{ "modals.add_personal.error_required" | translate }}
                    </span>
                  </div>
                </div>

                <div class="form-group" *ngIf="!(isOkMobility | async)">
                  <label class="label_form">
                    {{ "modals.add_personal.operator_input" | translate }}*
                  </label>
                  <ng-select
                    formControlName="operatorType"
                    [items]="operativeTypes"
                    bindLabel="name"
                    bindValue="value"
                    class="input_form"
                    placeholder="{{
                      'modals.add_personal.selectOperativeUser' | translate
                    }}"
                    [ngClass]="{
                      'has-error':
                        personalForm.get('operatorType')?.invalid &&
                        personalForm.get('operatorType')?.touched
                    }"
                  ></ng-select>
                  <div
                    *ngIf="
                      personalForm.get('operatorType')?.hasError('required') &&
                      personalForm.get('operatorType')?.touched
                    "
                  >
                    <span class="alert-text">
                      {{ "modals.add_personal.error_required" | translate }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Rol -->
              <div
               *ngIf="
  (isOkMobility | async) ||
  personalForm.get('operatorType')?.value === 'Interno'
"

                class="form-group"
              >
                <label class="label_form">
                  {{ "modals.add_personal.internalUserStatus" | translate }}*
                </label>
                <ng-select
                  formControlName="role"
                  [items]="rolesGeneral"
                  bindLabel="name"
                  bindValue="role"
                  class="input_form"
                  placeholder="{{
                    'modals.add_personal.selectInternalUser' | translate
                  }}"
                  [ngClass]="{
                    'has-error':
                      personalForm.get('role')?.invalid &&
                      personalForm.get('role')?.touched
                  }"
                ></ng-select>
                <div
                  *ngIf="
                    personalForm.get('role')?.hasError('required') &&
                    personalForm.get('role')?.touched
                  "
                >
                  <span class="alert-text">
                    {{ "modals.add_personal.error_required" | translate }}
                  </span>
                </div>
              </div>

              <!-- Dirección de inicio -->
              <div class="form-group">
                <label class="label_form">
                  {{ "modals.add_personal.star_address_input" | translate }}*
                </label>
                <input
                  #startAddressInput
                  formControlName="startAddress"
                  type="text"
                  class="form-control"
                  placeholder="{{
                    'modals.add_personal.star_address_input_inside' | translate
                  }}"
                  [ngClass]="{
                    'has-error':
                      personalForm.get('startAddress')?.invalid &&
                      personalForm.get('startAddress')?.touched
                  }"
                />
                <div
                  *ngIf="
                    personalForm.get('startAddress')?.hasError('required') &&
                    personalForm.get('startAddress')?.touched
                  "
                >
                  <span class="alert-text">
                    {{ "modals.add_personal.error_required" | translate }}
                  </span>
                </div>
                <input type="hidden" formControlName="startLatitude" />
                <input type="hidden" formControlName="startLongitude" />
              </div>

              <!-- Detalle de dirección de inicio -->
              <div class="form-group">
                <label class="label_form">
                  {{ "modals.add_personal.star_address_info_input" | translate }}
                </label>
                <tui-input
                  formControlName="startAddressDetail"
                  class="input_form"
                  [tuiTextfieldLabelOutside]="true"
                >
                  {{
                    "modals.add_personal.star_address_info_input_inside" | translate
                  }}
                </tui-input>
              </div>

              <!-- Uso transporte público -->
              <div class="form-group">
                <label class="label_form">{{"modals.add_personal.transport_type" | translate}}</label>
                <ui-checkbox
                  [checked]="personalForm.get('driverTransport')?.value"
                  (checkedChange)="personalForm.get('driverTransport')?.setValue($event)"
                  [disabled]="personalForm.get('driverTransport')?.disabled ?? false"
                  [label]="'modals.add_personal.public_transport_label' | translate"
                ></ui-checkbox>
              </div>

              <!-- Horario (Simplificado con placeholders de ejemplo) -->
              <div class="form-group">
                <span class="modal-body-title-section">
                  {{ "modals.add_personal.hour_section" | translate }}
                </span>
                <div class="hour-container">
                  <div class="col-md-6">
                    <label class="label_form">
                      {{ "modals.add_personal.star_hour_input" | translate }}*
                    </label>
                    <tui-input
                      formControlName="workdayStartTime"
                      class="input_form"
                      [tuiTextfieldLabelOutside]="true"
                      placeholder="08:00"
                      maxlength="5"
                      (input)="onTimeInput('start')"
                      [ngClass]="{
                        'has-error':
                          personalForm.get('workdayStartTime')?.invalid &&
                          personalForm.get('workdayStartTime')?.touched
                      }"
                    >
                      {{ "modals.add_personal.hour_placeholder" | translate }}
                    </tui-input>
                    <div
                      *ngIf="
                        personalForm.get('workdayStartTime')?.hasError('required') &&
                        personalForm.get('workdayStartTime')?.touched
                      "
                    >
                      <span class="alert-text">
                        {{ "modals.add_personal.error_required" | translate }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="label_form">
                      {{ "modals.add_personal.end_hour_input" | translate }}*
                    </label>
                    <tui-input
                      formControlName="workdayEndTime"
                      class="input_form"
                      [tuiTextfieldLabelOutside]="true"
                      placeholder="17:00"
                      maxlength="5"
                      (input)="onTimeInput('end')"
                      [ngClass]="{
                        'has-error':
                          personalForm.get('workdayEndTime')?.invalid &&
                          personalForm.get('workdayEndTime')?.touched
                      }"
                    >
                      {{ "modals.add_personal.hour_placeholder" | translate }}
                    </tui-input>
                    <div
                      *ngIf="
                        personalForm.get('workdayEndTime')?.hasError('required') &&
                        personalForm.get('workdayEndTime')?.touched
                      "
                    >
                      <span class="alert-text">
                        {{ "modals.add_personal.error_required" | translate }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tipo de servicio de moto -->
              <div class="form-group">
                <label class="label_form">
                  {{ "modals.add_personal.moto_input" | translate }}*
                </label>
                <ng-select
                  formControlName="allowedMotorcycleServiceType"
                  [items]="driverMotorcycleLicenseType"
                  bindLabel="name"
                  bindValue="type"
                  class="input_form"
                  placeholder="{{ 'modals.add_personal.motoServices' | translate }}"
                  [ngClass]="{
                    'has-error':
                      personalForm.get('allowedMotorcycleServiceType')?.invalid &&
                      personalForm.get('allowedMotorcycleServiceType')?.touched
                  }"
                ></ng-select>
                <div
                  *ngIf="
                    personalForm
                      .get('allowedMotorcycleServiceType')
                      ?.hasError('required') &&
                    personalForm.get('allowedMotorcycleServiceType')?.touched
                  "
                >
                  <span class="alert-text">
                    {{ "modals.add_personal.error_required" | translate }}
                  </span>
                </div>
              </div>

              <!-- Usuario activo -->
              <div class="form-group">
                <label class="label_form">
                  {{ "modals.add_personal.active_user_input" | translate }}*
                </label>
                <ng-select
                  formControlName="isActiveUser"
                  [items]="activeUsers"
                  bindLabel="name"
                  bindValue="value"
                  class="input_form"
                  placeholder="{{ 'modals.add_personal.select' | translate }}"
                  [ngClass]="{
                    'has-error':
                      personalForm.get('isActiveUser')?.invalid &&
                      personalForm.get('isActiveUser')?.touched
                  }"
                ></ng-select>
                <div
                  *ngIf="
                    personalForm.get('isActiveUser')?.hasError('required') &&
                    personalForm.get('isActiveUser')?.touched
                  "
                >
                  <span class="alert-text">
                    {{ "modals.add_personal.error_required" | translate }}
                  </span>
                </div>
              </div>

              <!-- Dirección de domicilio -->
              <div class="form-group">
                <label class="label_form">
                  {{ "modals.add_personal.domi_address_input" | translate }}*
                </label>
                <input
                  type="text"
                  formControlName="domicilioAddress"
                  #domicilioInput
                  class="form-control"
                  placeholder="{{
                    'modals.add_personal.domi_address_input_inside' | translate
                  }}"
                  [ngClass]="{
                    'has-error':
                      personalForm.get('domicilioAddress')?.invalid &&
                      personalForm.get('domicilioAddress')?.touched
                  }"
                />
                <div
                  *ngIf="
                    personalForm.get('domicilioAddress')?.hasError('required') &&
                    personalForm.get('domicilioAddress')?.touched
                  "
                >
                  <span class="alert-text">
                    {{ "modals.add_personal.error_required" | translate }}
                  </span>
                </div>
              </div>

              <!-- Detalle de domicilio -->
              <div class="form-group">
                <label class="label_form">
                  {{ "modals.add_personal.domi_address_info_input" | translate }}
                </label>
                <tui-input
                  formControlName="domicilioAddressExtraInfo"
                  class="input_form"
                  [tuiTextfieldLabelOutside]="true"
                >
                  {{
                    "modals.add_personal.domi_address_info_input_inside" | translate
                  }}
                </tui-input>
              </div>

              <!-- Tipo de documento -->

              <div class="form-group">
                <label class="label_form">
                  {{ "modals.add_personal.document_type" | translate }}
                </label>
                <ng-select
                  formControlName="identityDocumentType"
                  [items]="documentTypes"
                  bindLabel="label"
                  [clearable]="false"
                  bindValue="value"
                  class="input_form"
                  placeholder="{{
                    'modals.add_personal.document_type_input' | translate
                  }}"
                  [ngClass]="{
                    'has-error':
                      personalForm.get('identityDocumentType')?.invalid &&
                      personalForm.get('identityDocumentType')?.touched
                  }"
                >
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.label | translate }}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.label | translate }}
                  </ng-template>
                </ng-select>
              </div>

              <div
                class="form-group"
                *ngIf="
                  personalForm.get('identityDocumentType')?.value !== null &&
                  personalForm.get('identityDocumentType')?.value !==
                    DocumentType.WithoutDocument
                "
              >
                <label class="label_form">
                  {{ "modals.add_personal.document_number" | translate }}
                </label>
                <tui-input
                  formControlName="identityDocumentNumber"
                  class="input_form"
                  [tuiTextfieldLabelOutside]="true"
                  (input)="limitLength($event)"
                >
                  {{ "modals.add_personal.document_number_placeholder" | translate }}
                </tui-input>

                <div
                  *ngIf="
                    (personalForm.get('identityDocumentNumber')?.hasError('pattern') ||
                    personalForm.get('identityDocumentNumber')?.hasError('invalidNif') ||
                    personalForm.get('identityDocumentNumber')?.hasError('invalidNie') ||
                    personalForm.get('identityDocumentNumber')?.hasError('invalidRut') ||
                    personalForm.get('identityDocumentNumber')?.hasError('invalidPassport')) &&
                    personalForm.get('identityDocumentNumber')?.touched
                  "
                >
                  <span class="alert-text">
                    {{ "modals.add_personal.error_invalid_document" | translate }}
                  </span>
                </div>
              </div>

              <!-- Email principal y alternativo -->
              <div class="row gap-2">
                <div class="form-group">
                  <label class="label_form">
                    {{ "modals.add_personal.email_input" | translate }}*
                  </label>
                  <tui-input
                    formControlName="mainEmail"
                    class="input_form"
                    [tuiTextfieldLabelOutside]="true"
                    placeholder="ejemplo@correo.com"
                  >
                    {{ "modals.add_personal.email_input_inside" | translate }}
                  </tui-input>
                  <div
                    *ngIf="
                      personalForm.get('mainEmail')?.hasError('required') &&
                      personalForm.get('mainEmail')?.touched
                    "
                  >
                    <span class="alert-text">
                      {{ "modals.add_personal.error_required" | translate }}
                    </span>
                  </div>
                  <div
                    *ngIf="
                      personalForm.get('mainEmail')?.hasError('pattern') &&
                      personalForm.get('mainEmail')?.touched
                    "
                  >
                    <span class="alert-text">
                      {{ "modals.add_personal.error_invalid_email" | translate }}
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label class="label_form">
                    {{ "modals.add_personal.extra_email_input" | translate }}
                  </label>
                  <tui-input
                    formControlName="alternativeEmail"
                    class="input_form"
                    [tuiTextfieldLabelOutside]="true"
                    placeholder="ejemplo2@correo.com"
                  >
                    {{ "modals.add_personal.extra_email_input_inside" | translate }}
                  </tui-input>
                  <div
                    *ngIf="
                      personalForm.get('alternativeEmail')?.hasError('pattern') &&
                      personalForm.get('alternativeEmail')?.touched
                    "
                  >
                    <span class="alert-text">
                      {{ "modals.add_personal.error_invalid_email" | translate }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Teléfono principal y alternativo -->
              <div class="row gap-2">
                <div class="form-group">
                  <label class="label_form">
                    {{ "modals.add_personal.phone_input" | translate }}*
                  </label>
                  <tui-input-phone-international
                    formControlName="phoneNumber"
                    [countries]="(countriesPhone | tuiSortCountries | async) || []"
                    [(countryIsoCode)]="countryIsoCode"
                    class="input_form2"
                    [tuiTextfieldLabelOutside]="true"
                    (click)="openPhoneContainer($event)"
                    placeholder="+34 600 000 000"
                  ></tui-input-phone-international>
                  <div
                    *ngIf="
                      personalForm.get('phoneNumber')?.hasError('required') &&
                      personalForm.get('phoneNumber')?.touched
                    "
                  >
                    <span class="alert-text">
                      {{ "modals.add_personal.error_required" | translate }}
                    </span>
                  </div>
                  <div
                    *ngIf="
                      personalForm.get('phoneNumber')?.hasError('invalidFormat') &&
                      personalForm.get('phoneNumber')?.touched
                    "
                  >
                    <span class="alert-text">
                      {{ "modals.add_personal.invalid_phone" | translate }}
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label class="label_form">
                    {{ "modals.add_personal.extra_phone_input" | translate }}
                  </label>
                  <tui-input-phone-international
                    formControlName="alternativePhoneNumber"
                    [countries]="(countriesPhone | tuiSortCountries | async) || []"
                    [(countryIsoCode)]="countryIsoCodeExtra"
                    class="input_form2"
                    (click)="openPhoneContainer($event)"
                    [tuiTextfieldLabelOutside]="true"
                    placeholder="+34 600 000 001"
                    #phoneDropdown
                  ></tui-input-phone-international>

                  <div
                    *ngIf="
                      personalForm
                        .get('alternativePhoneNumber')
                        ?.hasError('invalidFormat') &&
                      personalForm.get('alternativePhoneNumber')?.touched
                    "
                  >
                    <span class="alert-text">
                      {{ "modals.add_personal.invalid_phone" | translate }}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>
          </form>
        </div>

        <!-- ---------- Footer ---------- -->
        <div class="modal-footer">
          <button
            tuiButton
            type="button"
            size="m"
            appearance="secondary"
            class="btn_desc"
            (click)="closeCanvas()"
          >
            {{ "modals.add_personal.close_modal_text" | translate }}
          </button>

          <button
            tuiButton
            type="button"
            size="m"
            appearance="primary-button"
            [disabled]="loadingAddOrEditData"
            (click)="savePersonal()"
            [icon]="driverInfo ? 'tuiIconEditLarge' : 'tuiIconPlusCircleLarge'"
          >
            <!-- Si NO está cargando, mostramos texto + icono -->
            <ng-container *ngIf="!loadingAddOrEditData; else loadingTemplate">
              <span *ngIf="!driverInfo">
                {{ "modals.add_personal.add_button_text" | translate }}
              </span>
              <span *ngIf="driverInfo">
                {{ "modals.add_personal.edit_button_text" | translate }}
              </span>
            </ng-container>

            <!-- Si está cargando, mostramos un spinner centrado -->
            <ng-template #loadingTemplate>
              <div class="button-spinner-wrapper">
                <tui-loader size="s"></tui-loader>
              </div>
            </ng-template>
          </button>
        </div>
      </div>
